export type WcsTooltipPosition = 'top' | 'bottom' | 'right' | 'left';
export type WcsTooltipAppendTo = Element | 'parent' | ((ref: Element) => Element);